import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { SendComponent } from '@app/client/uploader/desktop/modules/send/send.component';
import * as fromUploader from '@app/client/uploader/store/reducers';
import { getPathWithoutLastFragment } from '@app/shared/helpers/location';
import { Store } from '@ngrx/store';
import { UploaderStatus } from '@smash-sdk/uploader';
import { Observable, ReplaySubject, of } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DropboxSendGuard {

  constructor(
    private store$: Store<fromUploader.State>,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }
    return this.isUploading().pipe(map((isUploading) => {
      return isUploading;
    }));
  }

  canDeactivate(component: SendComponent) {
    return (() => component.canDeactivate())();
  }

  isUploading(): Observable<boolean> {
    const isUploading$ = new ReplaySubject<boolean>();
    this.store$.select(fromUploader.getUploadStatus).pipe(
      takeUntil(isUploading$)
    ).subscribe((status) => {
      if (status === UploaderStatus.Started) {
        isUploading$.next(true);
      } else {
        this.router.navigate([getPathWithoutLastFragment()]);
        isUploading$.next(false);
      }
    });
    return isUploading$.asObservable();
  }

}
